import _ from 'lodash'
import Mustache from 'mustache'
import React, { Suspense } from 'react'

import BIMESSAGES from 'core/data-model/constants/bi-messages'
import MESSAGES from 'core/data-model/constants/messages'
import VALUES from 'core/data-model/constants/values'
import { formatNumber } from 'core/service/lib/number-format'
import { getServiceWrapper } from 'core/service-wrapper'
import { getBasicPlanCodeForMRTA, getProductCodeForMRTA } from 'quick-quote/product-mrta/coverage-plan/selectors.utils'

const _getProductName = (productName, displayProduct) => {
  var planCode
  const code = getProductCodeForMRTA(displayProduct)
  const basicPlanCode = getBasicPlanCodeForMRTA(displayProduct)
  switch (basicPlanCode) {
    case VALUES.MRTA_CODE.MRTA_FULL:
      planCode = BIMESSAGES.MRTA_FULL_EN_NAME
      break
    case VALUES.MRTA_CODE.MRTA_PLUS:
      planCode = BIMESSAGES.MRTA_PLUS_EN_NAME
      break
    case VALUES.MRTA_CODE.MRTA_TRUNCATE:
      planCode = BIMESSAGES.MRTA_TRUNCATE_EN_NAME
      break
    case VALUES.GLTSP_CODE.GLTSP:
      planCode = basicPlanCode
      break
    default:
      planCode = code
      break
  }
  return Mustache.render(BIMESSAGES.BASIC_PLAN_DETAILS_MRTA, {
    name: productName,
    planCode: planCode,
    code: code,
  })
}

const renderGraph = (basicPlanCode) => {
  const serviceWrapper = getServiceWrapper()
  const className = `graph-${basicPlanCode}`
  return (
    <Suspense fallback={null}>
      {(() => {
        switch (basicPlanCode) {
          case VALUES.MRTA_CODE.MRTA_FULL:
            return serviceWrapper.renderGraph('MRTA_FULL', className)
          case VALUES.MRTA_CODE.MRTA_PLUS:
            return serviceWrapper.renderGraph('MRTA_PLUS', className)
          case VALUES.MRTA_CODE.MRTA_TRUNCATE:
            return serviceWrapper.renderGraph('MRTA_TRUNCATE', className)
          case VALUES.GLTSP_CODE.GLTSP:
            return serviceWrapper.renderGraph('GLTSP', className)
          default:
            return null
        }
      })()}
    </Suspense>
  )
}

const ProductBenefitsSummary = ({
  displayProduct,
  sumAssured,
  basicPremium,
  calculatedPaymentPeriod,
  calculatedCoveragePeriod,
  benefitSummaryHeader,
  selectedModelFactorID,
  selectedModelFactorLabel,
  sumAssuredContract,
}) => {
  const productName = _.isFunction(benefitSummaryHeader)
    ? // $$FlowFixMe
      benefitSummaryHeader({
        displayProduct,
        sumAssured,
        basicPremium,
        calculatedPaymentPeriod,
        calculatedCoveragePeriod,
      })
    : benefitSummaryHeader
  return (
    <div id="product-benefits-summary" className="product">
      <h3 className="name">{_getProductName(productName, displayProduct)}</h3>
      <div className="info-list">
        <div id="benefits-coverage-period" className="info">
          <p className="label">{BIMESSAGES.COVERAGE_PERIOD}</p>
          <p className="value">
            {calculatedCoveragePeriod} {MESSAGES.TIME_UNIT_YEAR}
          </p>
        </div>
        <div id="benefits-payment-period" className="info">
          <p className="label">{BIMESSAGES.PAYMENT_PERIOD}</p>
          <p className="value">
            {selectedModelFactorID === 'model-factor_5' ? selectedModelFactorLabel : calculatedPaymentPeriod + ' ปี'}
          </p>
        </div>
        <div id="benefits-sum-assured" className="info">
          <p className="label">{BIMESSAGES.BASIC_PLAN_SUM_ASSURED}</p>
          <p className="value">
            {formatNumber(sumAssuredContract)} {MESSAGES.BAHT}
          </p>
        </div>
        <div id="benefits-basic-premium" className="info">
          <p className="label">{BIMESSAGES.BASIC_PREMIUM}</p>
          <p className="value">
            {formatNumber(basicPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
      </div>
      {displayProduct ? renderGraph(getBasicPlanCodeForMRTA(displayProduct)) : ''}
    </div>
  )
}

export default ProductBenefitsSummary
